import { NgModule, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';

// @ts-ignore
type Params = Parameters<typeof Router['navigateByUrl']>;

@NgModule()
export class E2eModule {
    constructor() {
        const router = inject(Router);
        const zone = inject(NgZone);

        (window as any).navigateByUrl = (...params: Params) => {
            // @ts-ignore
            zone.run(() => router.navigateByUrl(...params));
        };
    }
}
